import React, { useState, useEffect } from "react";
import { makeStyles } from "@mui/styles";

import api from "../../services/api";
import ImageViewer from "../ImageViewer";

const useStyles = makeStyles(() => ({
	messageMedia: {
		objectFit: "cover",
		width: 250,
		height: 200,
		borderRadius: 8,
		cursor: "zoom-in",
		display: "block",
	},
	placeholder: {
		width: 250,
		height: 200,
		borderRadius: 8,
		background: "rgba(0,0,0,0.06)",
	},
}));

// /public exige token JWT, então buscamos a imagem via `api` (Authorization)
// como blob. Ao clicar, abre o ImageViewer (zoom + pan) sobre o mesmo blob.
const ModalImageCors = ({ imageUrl }) => {
	const classes = useStyles();
	const [blobUrl, setBlobUrl] = useState("");
	const [open, setOpen] = useState(false);

	useEffect(() => {
		if (!imageUrl) return undefined;
		let alive = true;
		let obj = "";
		(async () => {
			try {
				const { data, headers } = await api.get(imageUrl, { responseType: "blob" });
				obj = window.URL.createObjectURL(
					new Blob([data], { type: headers["content-type"] })
				);
				if (alive) setBlobUrl(obj);
			} catch {
				/* mídia indisponível */
			}
		})();
		return () => {
			alive = false;
		};
	}, [imageUrl]);

	if (!blobUrl) return <div className={classes.placeholder} />;

	return (
		<>
			<img
				className={classes.messageMedia}
				src={blobUrl}
				alt="imagem"
				onClick={() => setOpen(true)}
			/>
			{open && <ImageViewer src={blobUrl} onClose={() => setOpen(false)} />}
		</>
	);
};

export default ModalImageCors;
